"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Design = void 0;
const breakpoint = 1023;
const getResponsiveNavigationType = (width) => {
    return width > breakpoint ? 'pane' : 'slideout';
};
exports.Design = {
    breakpoint,
    getResponsiveNavigationType,
};
//# sourceMappingURL=design.js.map